module.exports = __webpack_public_path__ + "static/media/vtex14.fd759197.png";